import { plainToInstance, Type } from 'class-transformer'
import { TaskBase } from '@core/entities/task/TaskBase'
import { ITask } from '@core/entities/task/Task'
import { TemplateProjectLocations } from '@core/entities/template/TemplateProjectLocations'

export class Task extends TaskBase<ITask> {
  @Type(() => TemplateProjectLocations)
  projectLocations?: TemplateProjectLocations

  public static new(payload: unknown): Task {
    const entity = plainToInstance(Task, payload)

    return entity
  }
}
